import Address from 'src/models/Address';
import IOwner from 'src/models/IOwner';
import PhoneNumberChanges from 'src/models/PhoneNumberChanges';

export default class OwnerStateLand implements IOwner {
    constructor(owner: OwnerStateLand) {
        Object.assign(this, owner);
    }
    id: number;
    stateId: number;
    agencyName: string;
    addressId: number;
    address: Address;
    phoneNumberChanges?: PhoneNumberChanges;
    contactPersonDetailsId: number;
    contactPersonFirstName: string;
    contactPersonLastName: string;
    phoneNumber: string;
    addressInformationDate: Date;
    containerOwnerId: number;
    ownerLookUpId: number;
    ownerType: string;
    note: string;
    isPrimaryDeviation: boolean;
    isClientAcreage: boolean;
    email?: string;
    ssnTaxId?: string;

    ownerName() {
        return this.agencyName;
    }
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/add_ownership_revised/OwnerStateLand.ts